import React from "react";

import { formatNumber } from "utils";

import { Card, Col, MapInteractive, Typography } from "components";

export const UserReportedMap = ({ field, geometry, location, markers }) => (
  <>
    <Col sm={24} md={12}>
      <Typography variant="h4">User reported size</Typography>
      <Typography variant="paragraph-m">{formatNumber({ number: parseFloat(field.size), decimalPlaces: 4 })}ha</Typography>
      <Card className="map-card">
        <MapInteractive
          field={field}
          geometry={geometry}
          location={location}
          markers={markers.map((marker) => ({
            ...marker,
            size: "l",
          }))}
          scaleControl={true}
          zoomControl={true}
        />
      </Card>
    </Col>
  </>
);
